// removed by extract-text-webpack-plugin
module.exports = {"location":"src-components-contact----Location-module---location---1jVkl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/contact/Location.module.css
// module id = 180
// module chunks = 35783957827783 36829835628245 276599015875551